import { supabaseClient } from "../services/supabase";

export type AuditLevel =
  | "info"
  | "success"
  | "warning"
  | "error"
  | "security";

export type AuditEventInput = {
  userId?: string | null;

  employeeId?: string | null;
  employeeName?: string | null;
  employeeLoginId?: string | null;

  eventType: string;

  level?: AuditLevel;

  module?: string;

  entityType?: string;
  entityId?: string | null;

  description?: string;

  metadata?: Record<string, unknown>;
};

export async function logAuditEvent(
  event: AuditEventInput,
) {
  try {
    const { error } = await supabaseClient
      .from("audit_events")
      .insert({
        user_id: event.userId ?? null,

        employee_id:
          event.employeeId ?? null,

        employee_name:
          event.employeeName ?? null,

        employee_login_id:
          event.employeeLoginId ?? null,

        event_type: event.eventType,

        level:
          event.level ?? "info",

        module:
          event.module ?? null,

        entity_type:
          event.entityType ?? null,

        entity_id:
          event.entityId ?? null,

        description:
          event.description ?? null,

        metadata:
          event.metadata ?? {},
      });

    if (error) {
      console.error(
        "Erro ao registrar evento no Diário:",
        error,
      );
    }
  } catch (error) {
    console.error(
      "Falha inesperada no Diário da Arena:",
      error,
    );
  }
}